import styled from "styled-components";

export const FiltersContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  max-width: 1400px;
  padding-inline: 0;
`;

export const FiltersColumn = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 1;
  flex-wrap: wrap;
`;

export const SearchContainer = styled.div`
  min-width: 200px;
`;

